<div class="booking-modal-overlay" *ngIf="booking.isOpen" (click)="booking.close()">
  <div class="booking-modal" (click)="$event.stopPropagation()">
    <button class="booking-modal-close" type="button" aria-label="Close" (click)="booking.close()">
      <i class="fa-solid fa-xmark"></i>
    </button>
    <p class="booking-modal-label">BOOK WITH</p>
    <h3 class="booking-modal-title">Choose Your Artist</h3>
    <a class="booking-modal-option" *ngFor="let artist of booking.artists"
      [href]="artist.url" target="_blank" rel="noopener" (click)="booking.close()">
      <span class="booking-modal-info">
        <span class="booking-modal-name">{{ artist.name }}</span>
        <span class="booking-modal-role">{{ artist.role }}</span>
      </span>
      <i class="fa-solid fa-arrow-right"></i>
    </a>
  </div>
</div>
